// Allowed tab segments for /studio/:projectId?/:tab? URLs. Kept as a small
// pure module so routing/redirect logic in Studio can stay dumb and tests
// don't need to boot the router.
export const STUDIO_TABS = ['overview', 'footage', 'edits'];
export const DEFAULT_STUDIO_TAB = 'overview';

// Returns the validated tab name, or null when the input isn't a recognized
// tab. `undefined`/missing is treated the same as unknown — Studio then
// substitutes DEFAULT_STUDIO_TAB where a concrete tab is required.
export function normalizeTab(param) {
  if (typeof param !== 'string') return null;
  return STUDIO_TABS.includes(param) ? param : null;
}
